import { Box, Text } from "@chakra-ui/react";
import React from "react";
import { entityProfileModalColors } from "../entityProfileModal.theme";

type Props = {
  label: string;
  value: React.ReactNode;
};

export default function EntityProfileField(props: Props) {
  return (
    <Box minW={0}>
      <Text
        color={entityProfileModalColors.secondaryText}
        fontSize="12px"
        fontWeight={700}
        mb={1}
        textTransform="uppercase"
      >
        {props.label}
      </Text>
      <Text color={entityProfileModalColors.text} fontSize="14px" lineHeight="1.35" minH="19px">
        {props.value}
      </Text>
    </Box>
  );
}
